const text = `------=mhtDocumentPart
Content-Type: <%= contentType %>
Content-Transfer-Encoding: <%= contentEncoding %>
Content-Location: <%= contentLocation %>

<%= encodedContent %>`
export default text